<template>
    <section class="app-main">
        
        <el-card class="content">
            <el-table :data="tableData" empty-text="暂无优惠券"  height="600">
                <el-table-column prop="discount"  align="center" label="类型">
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.discount == 1">商品代金券</el-link>
                        <el-link type="warning" v-if="scope.row.discount == 3">商品折扣券</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="discount"  align="center" label="优惠">
                    <template slot-scope="scope">
                        <el-link type="danger" v-if="scope.row.discount == 1">C${{scope.row.coupon_money}}</el-link>
                        <el-link type="danger" v-if="scope.row.discount == 3">{{scope.row.coupon_money}}%</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="date"  align="center" label="有效日期" width="185">
                    <template slot-scope="scope">
                        <el-link type="success" v-if="scope.row.fixed == 1">开始：{{scope.row.st_time}}</el-link>
                        <el-link type="warning" v-if="scope.row.fixed == 1">结束：{{scope.row.end_time}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="flag"  align="center" label="状态">
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.flag == 0">未启用</el-link>
                        <el-link type="success" v-if="scope.row.flag == 1">已启用</el-link>
                        <el-link type="info"    v-if="scope.row.flag == 2">已禁用</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="code"  align="center" label="兑换码" >
                    <template slot-scope="scope">
                        <el-popover placement="top" trigger="hover"  v-show="!scope.row.edit">
                            <el-button type="success" plain size="small" @click="handleCopy(scope.row.exchange_code)">点击复制</el-button>
                            <el-button type="primary" plain size="small" @click="handleEdit(scope.row)">点击修改</el-button>
                            <el-button slot="reference"   type="text">{{scope.row.exchange_code}}</el-button>
                        </el-popover>
                        <el-input v-show="scope.row.edit" v-model="code" @keyup.enter.native="handleEditCode()" @blur="handleEditCode()" size="mini" class="edit-input"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <div slot-scope="scope" class="table-btns">
                        <!-- <el-button type="primary" plain size="mini" @click="handleShow(scope.row)">修改</el-button> -->
                        <el-button type="success" plain size="mini" @click="handleFlag(scope.row, 1)">启用</el-button>
                        <el-button type="info"    plain size="mini" @click="handleFlag(scope.row, 2)">禁用</el-button>
                        <el-button type="danger"  plain size="mini"  @click="handleDel(scope.row)">删除</el-button>
                    </div>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="20"></el-pagination>
        </el-card>


    </section>
</template>



<script>
import { coupon_list, coupon_put, coupon_del } from '@/api/market.js'
export default {
    data() {
        return {
            tableData:[],
            total:0,
            page:1,
            row: {},    // 修改行数据
            code: '',  // 兑换码 
        }
    },
    methods: {
        search(){
           
        },
        getData(){
            let params = {
                page:this.page,
                exchange_code: 1,
            }
            coupon_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.tableData.forEach(e => {
                        this.$set(e, 'edit', false)
                    })

                }else{
                    this.tableData = [];
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
        },
       
       // 启用  禁用
       handleFlag(row, flag) {
           let params = {
               flag: flag
           }
           coupon_put(row.id, params).then(res => {
               if(res) {
                    this.$message({type:"success",message:res.msg})
                    row.flag = flag
               }
           })
       },
        

        // 删除优惠券
        handleDel(row) {
             this.$confirm(`此操作将删除当前优惠券，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                coupon_del(row.id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.getData();
                })
            })
        },

        // 复制兑换码
        handleCopy(code) {
            navigator.clipboard.writeText(''+code);
            this.$message({type:"success",message: '复制成功！'})
        },

        // 显示修改兑换码输入框
        handleEdit(row){
            row.edit = true
            this.row = row
            this.code = row.exchange_code
        },

        // 修改 兑换码
       handleEditCode() {
           let params = {
               exchange_code: this.code
           }
           coupon_put(this.row.id, params).then(res => {
               if(res) {
                    this.$message({type:"success",message:res.msg})
                    this.row.exchange_code = this.code
                    this.row.edit = false
               }
           })
       },

    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .content {
        margin-top: 20px;
    }
    ::v-deep .el-input--mini .el-input__inner {
        text-align: center;
    }
}
</style>
